module.exports = __webpack_public_path__ + "static/media/user-add.c2c1684a.svg";